import truncate from 'truncate-html';

export let handleTruncate = ($element, limit = 450) => {
	let html = $element.html();
	let text = $element.text();
	if(text.length > limit) {
		
		let trimmedHtml = truncate(html, limit, {
			ellipsis: ` …`
		});
		$element.html(trimmedHtml);
	}
};
